import { useContext } from 'react'
import { GlobalContext } from '../global-context'
import { useAlloyApi } from '../api-context'
import { useUser } from './auth/useUser'
import { useQuery } from '@tanstack/react-query'
import { useIsMounted } from './useIsMounted'

export function useAlloys() {
    const { alloys, setAlloys } = useContext(GlobalContext)
    const alloyApi = useAlloyApi()
    const { user } = useUser()
    const isMounted = useIsMounted()

    const { refetch } = useQuery({
        queryKey: ['getAllAlloys', user?.id],
        queryFn: async () => {
            const alloys = (await alloyApi.getAllDefaultWithUserSpecific()).data
            setAlloys(alloys)
            return alloys
        },
        staleTime: 60000,
        enabled: isMounted,
    })

    return { alloys, refetch }
}
